export default function isValidPaymentContractStatus(status: string) {
  return ['PENDING', 'ACTIVE', 'IN_PROCESS'].includes(status);
}
